import NotFound from "@/features/Common/components/NotFound";

export default function NotFoundPage() {
  return <NotFound />;
}
